import { Col, InputNumber, Row } from "antd";

function EditTradePremium({
  tradedPremium,
  editTradeValue,
  setEditTradeValue,
  editVolatilityValue,
  setEditVolatilityValue,
  setIsRequestActive,
  isTradeRequestFire,
  disabled,
  tradedVolatility,
}) {
  return (
    <Row gutter={[10, 0]}>

      <Col span={6}>
        <p className="m-0">{tradedVolatility?.label}</p>
        <InputNumber
          disabled={
            isTradeRequestFire === null ||
            disabled ||
            tradedVolatility?.vol?.is_disabled
          }
          type="number"
          role="input"
          className="trade-volatility-input"
          onStep={() => setIsRequestActive(true)}
          onInput={() => setIsRequestActive(true)}
          onFocus={() => setIsRequestActive(true)}
          onBlur={() => setIsRequestActive(false)}
          value={
            editVolatilityValue !== undefined
              ? editVolatilityValue
              : tradedVolatility?.vol?.value
          }
          onChange={(value) => setEditVolatilityValue(value)}
          addonAfter={tradedVolatility?.vol?.symbol}
          step={tradedVolatility?.vol?.step_size || 0.005}
          style={{ marginLeft: "auto" }}
        />
      </Col>

      <Col span={6}>
        <p className="m-0">{tradedPremium?.label}</p>
        <InputNumber
          disabled={isTradeRequestFire === null || disabled}
          type="number"
          role="input"
          className="trade-premium-input"
          onStep={() => setIsRequestActive(true)}
          onInput={() => setIsRequestActive(true)}
          onFocus={() => setIsRequestActive(true)}
          onBlur={() => setIsRequestActive(false)}
          value={
            editTradeValue !== undefined
              ? editTradeValue
              : tradedPremium?.premium?.value
          }
          onChange={(value) => setEditTradeValue(value)}
          addonAfter={tradedPremium?.premium?.symbol}
          step={tradedPremium?.premium?.step_size || 0.005}
          style={{ marginLeft: "auto", width: "100%" }}
        />
      </Col>
    </Row>
  );
}

export default EditTradePremium;
